import { TAppState } from '../../types/appState';

export function sourceSelector(state: TAppState) {
  return state.source;
}
